import React from 'react';
import PageIframe from 'App/components/PageIframe/PageIframe';
import { usePageIframeInit } from 'App/components/PageIframe/usePageIframeInit';
import './AgentPage.scss';

type Props = {
	/** Slug of the agent_page to embed (placement === 'clientCard'). */
	slug: string;
	/** The account this card belongs to — exposed to the page via `useAccount()`. */
	clientId: number;
};

/**
 * Embeds a sandboxed Upsales Page (placement: 'clientCard') as a tab on the
 * company card. Unlike the standalone `PageView`, this passes the account's
 * `clientId` into the iframe init so the page's `useAccount()` hook resolves to
 * the company being viewed (WEB-6978).
 */
export default function AgentPage({ slug, clientId }: Props) {
	const init = usePageIframeInit(clientId);

	return (
		<div className="ClientCardAgentPage">
			<PageIframe slug={slug} init={init} />
		</div>
	);
}
